
import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator'
import IconAction from '@/components/IconAction/IconAction.vue'
import Widget from '@/components/Widget/Widget.vue'
import ViewModel from '@/models/ViewModel'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import DataTable from '@/components/DataTable/index.vue'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import AudienceSegmentsModule from '@/models/AudienceSegments'
import FooterNav from '@/components/FooterNav/FooterNav.vue'
import WebMessage from '@/models/WebMessage'
import dataMarketFields from './data-market-fields'

@Component({
  components: {
    IconAction,
    Widget,
    SearchInput,
    DataTable,
    FooterNav,
  },
})
export default class DataMarketplace extends ViewModel {
  @Ref() readonly dataTable!: DataTable

  public ready: boolean = false

  public query: string[] = ['status:active']

  public query_settings: any = {
    custom_fields: [
      {
        name: 'status:active',
        value: 'status:active',
        description: 'Filter active rules',
      },
      {
        name: 'status:inactive',
        value: 'status:inactive',
        description: 'Filter inactive rules',
      },
    ],
  }

  public show_filter_helper: boolean = false

  public filter_mode: string = 'all'

  public page: number = 1

  public records: number = 0

  public all_fields: any[] = []

  public fieldFilters: any = {}

  public selected_segments: string[] = []

  @Watch('query')
  public onQueryChange() {
    if (this.dataTable) {
      this.dataTable.page = this.page
    }
  }

  @Watch('filter_mode')
  public onFilterModeChange() {
    if (this.dataTable) {
      this.dataTable.page = this.page
    }
    this.refresh()
  }

  public get fields() {
    return this.all_fields.filter(field => field.show)
  }

  public refresh() {
    this.dataTable.refresh()
  }

  public resetFilters() {}

  mounted() {
    this.all_fields = dataMarketFields
    this.loadFilters()
    this.ready = true
  }

  public async marketRows(ctx: any) {
    this.loading = true
    const field_filters = Object.keys(this.fieldFilters)
      .filter((key: string) => this.fieldFilters[key] !== '')
      .map((key: string) => `${key}:${this.fieldFilters[key].toLowerCase()}`)

    this.syncFilters()

    return AudienceSegmentsModule.getMarketData({
      page_size: ctx.perPage,
      page: ctx.currentPage,
      order_by: ctx.sortBy,
      order: ctx.sortDesc ? 'desc' : 'asc',
      query: [...ctx.filter, ...field_filters],
      mode: this.filter_mode,
    }).then((result: any) => {
      this.records = result.records
      this.selected_segments = []
      this.loading = false
      this.ready = true
      return result.data
    })
  }

  public buySegments() {
    AudienceSegmentsModule.buySegmnents(this.selected_segments).then((result: any) => {
      console.log({ result })
      if (result.status === 200) {
        WebMessage.success('Segements purchese placed')
      } else if ([400, 500].includes(result.status)) {
        WebMessage.error('Error placing purchase')
      }
    })
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'data_market',
      data: { query: this.query, fieldFilters: this.fieldFilters, mode: this.filter_mode },
    })
  }

  public loadFilters() {
    const system = getModule(SystemtModule)
    system.getFilter('data_market').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
        this.filter_mode = filter.mode
      }
      this.ready = true
    })
  }

  public clearFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'data_market',
      data: null,
    })
  }
}
